/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Ingredients_By_ComponentInputs */

const en_recipe_ingredients_by_component = /** @type {(inputs: Recipe_Ingredients_By_ComponentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By component`)
};

const de_recipe_ingredients_by_component = /** @type {(inputs: Recipe_Ingredients_By_ComponentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach Komponente`)
};

/**
* | output |
* | --- |
* | "By component" |
*
* @param {Recipe_Ingredients_By_ComponentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_ingredients_by_component = /** @type {((inputs?: Recipe_Ingredients_By_ComponentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Ingredients_By_ComponentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_ingredients_by_component(inputs)
	return en_recipe_ingredients_by_component(inputs)
});